// extracted by mini-css-extract-plugin
export var active = "_de-7";
export var blink = "_de-8";
export var dropDownSelector = "_de-4";
export var dropDownWrapper = "_de-3";
export var fakeCursor = "_de-6";
export var fontSizeButton = "_de-9";
export var formQuillEditor = "_de-0";
export var pressed = "_de-a";
export var qlBlank = "_de-1";
export var textFormattingToolbar = "_de-2";
export var textToolbarOption = "_de-5";